import * as React from "react";
import {cx} from "emotion";

import "./card-line.scss";

import {cs}                  from "@Common/react/chain-services";
import {NumberInputBinding2} from "@Common/react/number-input-binding-2";
import {Checkbox}            from "@Common/ui-components/heavy/common/design2/checkbox/checkbox";
import {Radio}               from "@Common/ui-components/heavy/common/design2/radio/radio";

export const CardLine = (
    {
        card, multiple, selected,
        getAssumedAmount=undefined,
        onSaveCardAmount=undefined,
        onSelect, onEdit, onDelete,
    }
) => cs(
    ({}) => (
        <div
            className={cx("card-line card-line-7ed", {selected, "expired": card?.isExpiredCard})} key={card.token}
            onClick={card?.isExpiredCard || multiple ? null : onSelect}
        >
            <div className="selected-indicator">
                {multiple ? (
                    Checkbox({
                        checked: selected, xdQaName: card.cardNumber,
                        onClick: () => !card?.isExpiredCard && onSelect(),
                    })
                ) : (
                    Radio({selected, xdQaName: card.cardNumber})
                )}
            </div>

            <div className="details">
                <div className="line1">
                    <div className="number" xd-qa-type="label" xd-qa-name={card.cardNumber}>
                        {card.cardNumber}
                    </div>
                    <div className="actions">
                        <a
                            onClick={(e) => {
                                e.stopPropagation();
                                onEdit();
                            }}
                            xd-qa-type="link"
                            xd-qa-name={card.cardNumber+" Edit"}
                        >
                            Edit
                        </a>
                        <a
                            onClick={(e) => {
                                e.stopPropagation();
                                onDelete();
                            }}
                            xd-qa-type="link"
                            xd-qa-name={card.cardNumber+" Remove"}
                        >
                            Remove
                        </a>
                    </div>
                </div>
                <div className="exp" xd-qa-type="label" xd-qa-name={card.cardNumber+" Expiration"}>
                    Exp: {card.expiration}
                </div>
            </div>

            {selected && multiple && (
                <div className="amount">
                    {/*<i className="fa fa-usd"/>*/}

                    {cs(
                        ["binding", (_, next) => NumberInputBinding2({
                            value: card.amount,
                            getPlaceholder: () => {
                                const assumedAmount = getAssumedAmount(card);
                                return assumedAmount ? (
                                    "" + Math.round(assumedAmount * 100) / 100
                                ) : (
                                    "Enter amount to charge"
                                );
                            },
                            onSave: (num) => onSaveCardAmount(num, card ),
                            next,
                        })],
                        ({binding}) => (
                            <input {...{
                                ...binding.handle,
                                className: cx({"hasError": binding.hasError}),
                                "xd-qa-type":"text_field",
                                "xd-qa-name": card.cardNumber,
                            }}/>
                        ),
                    )}
                </div>
            )}

            <div className="spacer"/>

            <div className="icon">
                <img src={icons[card.cardType]} alt={card.cardType}/>
            </div>
        </div>
    ),
);

const icons = {
    "Visa": require("../../../../credit-card-icons/visa.svg"),
    "Discover": require("../../../../credit-card-icons/Discover_Card_logo.svg"),
    "American Express": require("../../../../credit-card-icons/amex.svg"),
    "MasterCard": require("../../../../credit-card-icons/mc.svg"),
};
